export class ToastMessages {
  static readonly ERROR_GENERIC = 'Ingen internetforbindelse. Billetsalg ikke muligt.';
  static readonly SUCCESS_CANCEL_ORDER = 'Billetten blev annulleret';
  static readonly ERROR_CANCEL_ORDER = 'Annulleringen fejlede';
  static readonly SUCCESS_GENERIC = 'Købet er gennemført';
  static readonly ERROR_PURCHASE_FAILED = "købet kunne ikke gennemføres. Prøv venligst igen";
  static readonly ERROR_JOURNEY_SEARCH_FAILED = "Kunne ikke finde rejsen. Tjek venligst start- og slutstoppested, og prøv igen";
  static readonly ERROR_LOCATION_FAILED = "Placering utilgængelig. Aktiver venligst lokalitetstjenester"
  static readonly ERROR_LOCATION_NOT_IN_DENMARK = "Din nuværende placering ser ud til at være uden for landet. Billetsalg er kun tilgængeligt i Danmark"
  static readonly ERROR_LOGOUT_FAIL = "Log ud fejlede";
  static readonly ERROR_BUSINESS_RULES = "Kan ikke hente priser";
  static readonly OPERATION_ID_MESSAGE = "Giv dette ID til operatøren";
  static readonly ERROR_SHIFT_FINISHED = "Dit vagt er allerede logget ind et andet sted. Funktionerne er derfor ikke tilgængelige";
}
